import React, { Component } from "react";
import Book from "../../Components/Book";

import "./HetVerhaalVanMascopiro.scss";

import intro from "../../Images/intro.png";

import book01 from "../../Images/boek_01.png";
import book02 from "../../Images/boek_02.png";
import book03 from "../../Images/boek_03.png";
import book04 from "../../Images/boek_04.png";
import book05 from "../../Images/boek_05.png";
import book06 from "../../Images/boek_06.png";
import book07 from "../../Images/boek_07.png";
import book08 from "../../Images/boek_08.png";
import book09 from "../../Images/boek_09.png";

class HetVerhaalVanMascopiro extends Component {
  render() {
    const books = [
      book01,
      book02,
      book03,
      book04,
      book05,
      book06,
      book07,
      book08,
      book09
    ];
    return (
      <div className="het-verhaal-van-mascopiro">
        <div className="intro">
          <img src={intro} alt="Introductie" />
          <span>
            Zijn jullie er klaar voor? <br /> Dan maken we het heel, heel
            stil...
          </span>
        </div>
        <Book books={books} />
      </div>
    );
  }
}

export default HetVerhaalVanMascopiro;
